/* Solar Finder: question tree and breadcrumb. Edit titles, subtitles, option labels and breadcrumb names here.
   stageLabels = breadcrumb names; flows = which breadcrumb steps each scenario shows (rv / marine / roof).
   Option images and result products are set in the theme editor. */
window.SolarFinderTree = {
  "start": "scenario",
  "stageLabels": {
    "scenario": "Scenarios",
    "specific": "Specific Scenarios",
    "purpose": "Purpose",
    "recommendation": "Recommendations"
  },
  "flows": {
    "default": [
      "scenario",
      "specific",
      "purpose",
      "recommendation"
    ],
    "rv": [
      "scenario",
      "specific",
      "recommendation"
    ],
    "marine": [
      "scenario",
      "specific",
      "recommendation"
    ],
    "roof": [
      "scenario",
      "specific",
      "purpose",
      "recommendation"
    ]
  },
  "nodes": {
    "scenario": {
      "stage": "scenario",
      "type": "choice",
      "title": "Choose Your Scenario",
      "subtitle": "Where will you build your power system?",
      "options": [
        {
          "id": "rv",
          "label": "RV",
          "next": "rv_type"
        },
        {
          "id": "marine",
          "label": "Marine",
          "next": "marine_type"
        },
        {
          "id": "roof",
          "label": "Roof",
          "next": "roof_material"
        }
      ]
    },
    "rv_type": {
      "stage": "specific",
      "type": "choice",
      "title": "Choose Your RV Type",
      "subtitle": "Help us establish the baseline.",
      "options": [
        {
          "id": "rv_suv",
          "label": "SUV",
          "result": "rv_compact"
        },
        {
          "id": "rv_truck",
          "label": "Truck",
          "result": "rv_compact"
        },
        {
          "id": "rv_golf_s",
          "label": "Golf Cart (under 4 seats)",
          "result": "rv_compact"
        },
        {
          "id": "rv_class_b",
          "label": "Class B",
          "next": "rv_space"
        },
        {
          "id": "rv_class_c",
          "label": "Class C",
          "next": "rv_space"
        },
        {
          "id": "rv_golf_l",
          "label": "Golf Cart (4–20 seats)",
          "next": "rv_space"
        },
        {
          "id": "rv_class_a",
          "label": "Class A",
          "result": "rv_large"
        },
        {
          "id": "rv_trailer",
          "label": "Trailer",
          "result": "rv_large"
        },
        {
          "id": "rv_remote",
          "label": "Remote Home",
          "result": "rv_large"
        }
      ]
    },
    "rv_space": {
      "stage": "specific",
      "type": "choice",
      "title": "Roof Space",
      "subtitle": "How much roof space do you have for panels?",
      "options": [
        {
          "id": "rv_space_limited",
          "label": "Limited Space",
          "result": "rv_mid_limited"
        },
        {
          "id": "rv_space_moderate",
          "label": "Moderate Space",
          "result": "rv_mid_moderate"
        }
      ]
    },
    "marine_type": {
      "stage": "specific",
      "type": "choice",
      "title": "Choose Your Boat Type",
      "subtitle": "Help us establish the baseline.",
      "options": [
        {
          "id": "marine_fishing",
          "label": "Fishing Boat",
          "result": "marine"
        },
        {
          "id": "marine_sail",
          "label": "Sailboat",
          "result": "marine"
        },
        {
          "id": "marine_yacht",
          "label": "Yacht",
          "result": "marine"
        }
      ]
    },
    "roof_material": {
      "stage": "specific",
      "type": "choice",
      "title": "Choose Your Roof Material",
      "subtitle": "Help us establish the baseline.",
      "options": [
        {
          "id": "roof_wood",
          "label": "Wood",
          "next": "roof_purpose"
        },
        {
          "id": "roof_metal",
          "label": "Metal",
          "next": "roof_purpose"
        },
        {
          "id": "roof_asphalt",
          "label": "Asphalt Shingles",
          "next": "roof_purpose"
        },
        {
          "id": "roof_tile",
          "label": "Tile",
          "next": "roof_purpose"
        },
        {
          "id": "roof_glass",
          "label": "Glass",
          "next": "roof_purpose"
        }
      ]
    },
    "roof_purpose": {
      "stage": "purpose",
      "type": "choice",
      "title": "Purpose",
      "subtitle": "What do you need solar power for?",
      "options": [
        {
          "id": "purpose_backup",
          "label": "Backup Power",
          "next": "backup_duration"
        },
        {
          "id": "purpose_cost",
          "label": "Lower Costs",
          "next": "bill_target"
        },
        {
          "id": "purpose_offgrid",
          "label": "Off-Grid",
          "next": "offgrid_size"
        }
      ]
    },
    "backup_duration": {
      "stage": "purpose",
      "type": "choice",
      "title": "Backup Duration",
      "subtitle": "How long do you need to keep the power on?",
      "options": [
        {
          "id": "backup_hours",
          "label": "A few hours",
          "result": "backup_hours"
        },
        {
          "id": "backup_1_2d",
          "label": "1–2 days",
          "result": "backup_1_2d"
        },
        {
          "id": "backup_3_4d",
          "label": "3–4 days",
          "result": "backup_3_4d"
        }
      ]
    },
    "bill_target": {
      "stage": "purpose",
      "type": "bill_target",
      "title": "Your Electricity Bill",
      "subtitle": "Enter your average monthly bill and pick how much of it to cover.",
      "options": [
        {
          "id": "target_25",
          "label": "25%",
          "next": "maintenance_25"
        },
        {
          "id": "target_50",
          "label": "50%",
          "next": "maintenance_50"
        },
        {
          "id": "target_75",
          "label": "75%",
          "next": "maintenance_75"
        }
      ],
      "billDefault": 142.26,
      "billLabel": "Average monthly electricity bill",
      "billHint": "US average shown. Enter yours if you like.",
      "targetTitle": "How much of your bill do you want solar to cover?"
    },
    "maintenance_25": {
      "stage": "purpose",
      "type": "choice",
      "title": "Maintenance Preference",
      "subtitle": "How do you want to handle upkeep?",
      "options": [
        {
          "id": "m_flowe",
          "label": "Reduce maintenance costs",
          "result": "lowcost_25_flowe"
        },
        {
          "id": "m_novar",
          "label": "Standard maintenance",
          "result": "lowcost_25_novar"
        }
      ]
    },
    "maintenance_50": {
      "stage": "purpose",
      "type": "choice",
      "title": "Maintenance Preference",
      "subtitle": "How do you want to handle upkeep?",
      "options": [
        {
          "id": "m_flowe",
          "label": "Reduce maintenance costs",
          "result": "lowcost_50_flowe"
        },
        {
          "id": "m_novar",
          "label": "Standard maintenance",
          "result": "lowcost_50_novar"
        }
      ]
    },
    "maintenance_75": {
      "stage": "purpose",
      "type": "choice",
      "title": "Maintenance Preference",
      "subtitle": "How do you want to handle upkeep?",
      "options": [
        {
          "id": "m_flowe",
          "label": "Reduce maintenance costs",
          "result": "lowcost_75_flowe"
        },
        {
          "id": "m_novar",
          "label": "Standard maintenance",
          "result": "lowcost_75_novar"
        }
      ]
    },
    "offgrid_size": {
      "stage": "purpose",
      "type": "choice",
      "title": "Roof Size",
      "subtitle": "Roughly how large is your roof?",
      "options": [
        {
          "id": "og_1",
          "label": "150–450 sq ft",
          "result": "offgrid_1",
          "hint": "Tiny house, small cabin"
        },
        {
          "id": "og_2",
          "label": "450–700 sq ft",
          "result": "offgrid_2",
          "hint": "Cabin, carport"
        },
        {
          "id": "og_3",
          "label": "700–1,800 sq ft",
          "result": "offgrid_3",
          "hint": "Large cabin, workshop"
        },
        {
          "id": "og_4",
          "label": "1,800–2,800 sq ft",
          "result": "offgrid_4",
          "hint": "House, farm building"
        },
        {
          "id": "og_5",
          "label": "2,800–3,000 sq ft",
          "result": "offgrid_5",
          "hint": "Large house, barn"
        }
      ]
    }
  }
};
